import type { ReactNode } from "react";
import { Trans } from "react-i18next";
import { cn } from "@/lib/utils";

const FACEBOOK_URL = "https://facebook.com/96digitallabs";
const WHATSAPP_URL = "https://wa.me/4915231480096";

function CreditLink({ href, children }: { href: string; children?: ReactNode }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="underline underline-offset-2 hover:text-foreground"
    >
      {children}
    </a>
  );
}

export function CompanyCredit({ className }: { className?: string }) {
  return (
    <p className={cn("text-[11px] leading-snug text-center text-muted-foreground", className)}>
      <Trans
        i18nKey="footer.credit"
        ns="common"
        components={{
          facebook: <CreditLink href={FACEBOOK_URL} />,
          whatsapp: <CreditLink href={WHATSAPP_URL} />,
        }}
      />
    </p>
  );
}
